export default "__VITE_ASSET__BRCNXJ7g__"